import { DialogContent, SxProps, Box, DialogActions, DialogTitle } from '@mui/material';
import { isString } from 'lodash';
import { Typography, IconButton } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import { SweepTypographyVariants } from '@sweep-io/sweep-design/dist/components/Typography/types';
import { BaseDialog, BaseDialogProps } from './BaseDialog';
import { DialogLoader } from './DialogLoader';
import { IconButtonSize } from '@sweep-io/sweep-design/dist/components/IconButton/types';

interface Props extends BaseDialogProps {
  titleJsx?: string | React.ReactNode;
  handleClose: (event: any) => any;
  PaperPropsSx?: SxProps;
  children: React.ReactNode;
  dialogSx?: SxProps;
  dialogContentSx?: SxProps;
  showCloseButton?: boolean;
  titleTypographyVariant?: SweepTypographyVariants;
  showLoader?: boolean;
  closeButtonSize?: IconButtonSize;
  dialogActions?: React.ReactNode;
  dialogTitleSx?: SxProps;
}

const InfoDialog = ({
  titleJsx,
  handleClose,
  PaperPropsSx,
  children,
  dialogSx,
  dialogContentSx,
  showCloseButton,
  titleTypographyVariant = 'h1-medium',
  showLoader,
  closeButtonSize = 'large',
  dialogActions,
  dialogTitleSx,
  ...rest
}: Props) => {
  const closeDialog = (event: any) => {
    handleClose && handleClose(event);
  };

  return (
    <BaseDialog
      keepMounted
      onClose={closeDialog}
      PaperProps={{
        sx: { ...PaperPropsSx },
      }}
      sx={dialogSx}
      {...rest}
    >
      {!titleJsx && showCloseButton && (
        <Box
          sx={{ position: 'absolute', right: '24px', top: '24px', zIndex: 2 }}
          className={'infoDialogCloseBtn'}
        >
          <IconButton variant="flat" size={closeButtonSize} onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      )}

      {titleJsx && (
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 1,
            paddingBottom: 1,
            ...dialogTitleSx,
          }}
        >
          {isString(titleJsx) ? (
            <Typography
              data-testid="alert-dialog-title"
              variant={titleTypographyVariant}
              whiteSpace="break-spaces"
            >
              {titleJsx}
            </Typography>
          ) : (
            <>{titleJsx}</>
          )}

          {showCloseButton && (
            <Box mt="-6px">
              <IconButton variant="flat" size={closeButtonSize} onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
          )}
        </DialogTitle>
      )}

      <DialogContent sx={{ ...dialogContentSx, pt: 4 }}>{children}</DialogContent>
      <DialogLoader visible={showLoader} />
      {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
    </BaseDialog>
  );
};

export { InfoDialog };
